import useEnvironment from './useEnvironment';
export * from './useEnvironment';
export default useEnvironment;
